import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from '#src/shared/error';

import { TopicPage } from './api.graphql';
import type { TopicPageQuery, TopicPageQueryVariables } from './api.graphql';
import type { TopicPageData } from './types';

export async function getTopicPageData({ gql: { fetch } }: UtilityContext, slug: string): Promise<TopicPageData> {
	const { data } = await fetch<TopicPageQuery, TopicPageQueryVariables>({
		query: TopicPage,
		variables: { slug },
		rejectOnError: true,
	});

	if (!data.topicPage) {
		throw new NotFoundError();
	}

	return data.topicPage;
}
